﻿import document from 'document';
import { eventBus } from '../../foundation/eventBus';
import { debounce } from '../../utilities/debounce';
import { events as formEvents } from '../../feature/form/enable-form';
import { ajaxRequest } from '../../utilities/ajax';

export const bankAccountLookup = () => {
    // API documentation https://www.pcapredict.com/support/webservice/bankaccountvalidation/interactive/validate/2/
    const selectors = {
        root: '.form',
        button: '.find-bank-account-btn',
        field: '.form-field-group__input',
        sortCodeField: '.js-sort-code',
        accountNumberField: '.js-account-number',
        errorMessage: '.form-field-group__error',
        resultError: '.find-bank-account-error',
        postcodeError: '.bank-postcode-error',
        continueBtn: '.form-button-group__submit-btn',
        hiddenFieldValidator: '.js-bank-valid'
    };

    let config = {}; // global object that gets mapped to later in the code

    const _makeRequest = (service, dataObj, func) => {

        const url = service.url + '?' + Object.keys(dataObj).map(
            (k) => { return encodeURIComponent(k) + '=' + encodeURIComponent(dataObj[k]) }
        ).join('&');
        ajaxRequest.get(url, dataObj, 'application/json', func);
    };

    const _populateAddress = (data) => {

        if (data != null && data != {}) {

            const fields = Array.from(document.querySelector(selectors.root).querySelectorAll(selectors.field));
            const addressKeys = Object.keys(data);

            function populateField(key) {
                const field = fields.filter((item) => {
                    const itemAttr = item.getAttribute('data-address-key');
                    if (itemAttr === key) {
                        return itemAttr;
                    }
                })[0];

                if (field) {
                    field.value = data[field.getAttribute('data-address-key')];
                    field.removeAttribute('aria-invalid');
                    field.removeAttribute(selectors.errorMessage);
                    field.classList.remove('visible');
                }
            }

            addressKeys.forEach(populateField);

            _validatePageBeacon();
        }
    };

    const _clearBankAddressFields = (data) => {
        const fields = Array.from(document.querySelector(selectors.root).querySelectorAll(selectors.field));
        const addressKeys = Object.keys(data);

        function clearField(key) {
            const field = fields.filter((item) => {
                const itemAttr = item.getAttribute('data-address-key');
                if (itemAttr === key) {
                    return itemAttr;
                }
            })[0];

            if (field) {
                field.value = '';
            }
        }

        addressKeys.forEach(clearField);
    }

    const _validatePageBeacon = () => {
        eventBus.publish(formEvents.validate);
    };

    const _validBankDetails = () => {
        document.querySelector(selectors.resultError).classList.remove('visible');
    };

    const _invalidBankDetails = () => {
        document.querySelector(selectors.resultError).classList.add('visible');
        _disableContinueBtn();
    };

    const _updateHiddenCheckbox = (state) => {
        document.querySelector(selectors.hiddenFieldValidator).check = state;
    };

    const _isHiddenCheckboxChecked = () => {
        return document.querySelector(selectors.hiddenFieldValidator).check;
    };

    const _hasBankAccountDetailsBeenCorrected = () => {
        // returns a true or false statement from the PCA api if the account number requires correction
        // due to acceptance criteria change we have hard coded the corrected details to false as of 18/01/2018
        return false;
    };

    const _correctAccountNumber = (data) => {
        // if PCA returns corrected details update the bank account number field
        document.querySelector(selectors.accountNumberField).value = data.correctedAccountNumber;
    };

    const _isDirectDebitCompatible = (data) => {
        // return a true or false if the bank account has direct debit capability
        return data.isDirectDebitCapable;
    };

    const _isCorrectBankDetails = (data) => {
        return data.isCorrect;
    };

    const _isBankPostcodeAvailable = (data) => {
        if (data.contactPostcode === '' || data.contactPostcode === null) {
            return false;
        }
        else {
            _validBankPostcode(data);
            return true;
        }
    };

    const _validBankPostcode = (data) => {
        if (!_isCorrectBankDetails(data)) {
            return;
        }
        document.querySelector(selectors.postcodeError).classList.remove('visible');
        _enableContinueBtn();
    };

    const _invalidBankPostcode = () => {
        document.querySelector(selectors.postcodeError).classList.add('visible');
        _disableContinueBtn();
    };

    const _enableContinueBtn = () => {
        document.querySelector(selectors.continueBtn).classList.remove('disabled');
    };

    const _disableContinueBtn = () => {
        if (!document.querySelector(selectors.continueBtn).classList.contains('disabled')) {
            document.querySelector(selectors.continueBtn).classList.add('disabled');
        }
    };

    const _responseActions = (data) => {
        var dataObj = JSON.parse(data);
        if (!_isBankPostcodeAvailable(dataObj)) {
            _clearBankAddressFields(dataObj);
            _invalidBankPostcode();
        }
        else if (_isCorrectBankDetails(dataObj) && _isDirectDebitCompatible(dataObj) && !_hasBankAccountDetailsBeenCorrected()) {
            _updateHiddenCheckbox(true);
            _populateAddress(dataObj);
            _validBankDetails();
        }
        else if (_isCorrectBankDetails(dataObj) && _isDirectDebitCompatible(dataObj) && _hasBankAccountDetailsBeenCorrected()) {
            _correctAccountNumber(dataObj);
            _updateHiddenCheckbox(true);
            _populateAddress(dataObj);
            _validBankDetails();
        }
        else {
            _updateHiddenCheckbox(false);
            _invalidBankDetails();
        }
    };

    const _getBranchDetails = (sortCode, accountNumber) => {
        if (sortCode != '' && accountNumber != '') {
            const branchDetails = [
                {
                    url: config.bankAccountValidatorService
                },
                {
                    AccountNumber: accountNumber,
                    SortCode: sortCode
                },
                function (data) {
                    _responseActions(data);
                }
            ];
            _makeRequest.apply(null, branchDetails);
        }
    };

    const _getSortCode = (el) => {
        return el.closest(selectors.root).querySelector(selectors.sortCodeField).value;
    };

    const _getAccountNumber = (el) => {
        return el.closest(selectors.root).querySelector(selectors.accountNumberField).value;
    };

    const _bindEvents = (root) => {
        const button = root.querySelector(selectors.button);
        button.addEventListener('click', (e) => {
            e.preventDefault();
            _getBranchDetails.call(
                null,
                _getSortCode(e.currentTarget),
                _getAccountNumber(e.currentTarget)
            );
            eventBus.publish(formEvents.validate);
        });

        root.querySelector(selectors.sortCodeField).addEventListener('input', _debounce);
        root.querySelector(selectors.accountNumberField).addEventListener('input', _debounce);
    };

    const _debounce = debounce(function () {
        if (_isHiddenCheckboxChecked()) {
            _updateHiddenCheckbox(false);
        }
    }, 200);

    const _getSettings = (root, resolve) => {
        const pcaBtn = root.querySelectorAll(selectors.button);

        if (pcaBtn.length > 0) {
            const element = pcaBtn[0];
            const data = {
                bankAccountValidatorService: element.dataset.bankAccountValidator
            };
            config = { ...config, ...data };
            resolve(true);
        }
    };

    const init = () => {
        const root = document.querySelectorAll(selectors.root)[0];
        if (root) {
            const readSettings = new Promise((resolve) => {
                _getSettings(root, resolve);
            });
            readSettings
                .then(() => {
                    _bindEvents(root);
                });
        }
    };

    return {
        init: init
    };
};
